var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('history',{attrs:{"text":this.$route.query.text,"searchIndex":this.$route.query.searchIndex,"searchTips":_vm.tips,"searchLink":_vm.link,"id":_vm.id,"hotType":this.$route.query.hotType}})}
var staticRenderFns = []

export { render, staticRenderFns }